module.exports = __webpack_public_path__ + "static/media/repairing-service.d908ee4b.svg";